class YGSwiper extends HTMLElement {
    constructor() {
        super();
    }

    #props = {
        gap: {
            type: Number,
            value: 20,
        },
        slidesPerView: {
            type: Number,
            value: 3,
        },
        mobileGap: {
            type: Number,
            value: 10,
        },
        mobileSlidesPerView: {
            type: Number,
            value: 1,
        }
    };

    #swiperOptions() {
        const that = this;
        return {
            spaceBetween: that.#props.mobileGap.value,
            slidesPerView: that.#props.mobileSlidesPerView.value,
            breakpoints: {
                700: {
                    spaceBetween: that.#props.gap.value,
                    slidesPerView: that.#props.slidesPerView.value,
                }
            }
        }
    }

    initSwiper() {
        this.classList.add('swiper');
        new Swiper(this, this.#swiperOptions());
    }

    initProps() {
        for (const { name, value } of this.attributes) {
            Object.keys(this.#props).forEach((key) => {
                if(key.toLowerCase() === name){
                    this.#props[key].value = this.#props[key].type(value);
                }
            })
        }
    }

    connectedCallback() {
        this.initProps();
        this.initSwiper();
    }
}
customElements.define('yg-swiper', YGSwiper);

document.addEventListener('DOMContentLoaded', function () {
  class YGSwiper2 extends HTMLElement {
      constructor() {
          super();
      }

      #swiperOptions = {
          spaceBetween: 10,
          slidesPerView: 1.3,
      };

      initSwiper() {
          this.classList.add('swiper');
          new Swiper(this, this.#swiperOptions);
      }

      connectedCallback() {
          this.initSwiper();
      }
  }

  customElements.define('yg-text-slide', YGSwiper2);

  window.ygMarkRemoveFlag = true;
});
